module.exports = __webpack_public_path__ + "static/media/brain3.cfeb5357.png";